import { supabase } from '@/lib/supabase/client';

export const logEvent = async (jobId: string, eventType: string, meta: Record<string, unknown>) => {
  const { error } = await supabase
    .from('audit_logs')
    .insert([{
      job_id: jobId,
      event_type: eventType, 
      meta, 
      created_at: new Date().toISOString()
    }]);
    
  if (error) console.error("Audit Log Failed:", error);
  return !error;
};
